import { Component, Input } from '@angular/core';

@Component({
    selector: 'topo-tag-pill',
    templateUrl: './tag-pill.component.html',
    styleUrls: ['./tag-pill.component.scss'],
    standalone: false
})
export class TagPillComponent {
  @Input() value: string;
}
